import { useMutation } from "@tanstack/react-query";
import { userDataInfo } from "../Components/utils";
import { API_BASE } from "../constants";

const addCustomerData = async (userInfo: userDataInfo) => {
  const path = `${API_BASE}/api/user/submit`;
  const response = await fetch(path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userInfo),
  });

  return await response;
};

export const useAddUserDetails = () => {
  return useMutation({
    mutationFn: (userInfo: userDataInfo) => addCustomerData(userInfo),
  });
};
